export const appConstant = {
  baseUrl: 'https://api.volitioncap.com/api',
};
